import { render, staticRenderFns } from "./PollutionBar.vue?vue&type=template&id=5e0396a1&"
import script from "./PollutionBar.vue?vue&type=script&lang=js&"
export * from "./PollutionBar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports